export default __webpack_public_path__ + "static/media/116.2e89cc15.jpg";